import { forwardRef, type Ref, type SVGProps } from "react";
const IconCatOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M13.363 14.752a1.388 1.388 0 1 1-2.776 0 1.388 1.388 0 0 1 2.776 0m8.119 0a1.388 1.388 0 1 1-2.776 0 1.388 1.388 0 0 1 2.776 0"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.52 19.193c0-.527.426-.954.953-.954h3.088a.954.954 0 1 1 0 1.908h-3.088a.954.954 0 0 1-.954-.954"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 18.273c.527 0 .954.428.954.955v.763a3.28 3.28 0 0 1-3.279 3.279.954.954 0 0 1 0-1.909 1.37 1.37 0 0 0 1.37-1.37v-.763c0-.527.428-.955.955-.955"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 18.273a.954.954 0 0 0-.954.955v.763a3.28 3.28 0 0 0 3.279 3.279.954.954 0 0 0 0-1.909 1.37 1.37 0 0 1-1.37-1.37v-.763a.954.954 0 0 0-.955-.955m-8.173.523a.954.954 0 0 1 0 1.35L3.63 24.342a.954.954 0 0 1-1.35-1.349l4.199-4.198a.954.954 0 0 1 1.35 0m2.774 2.638a.954.954 0 0 1 0 1.35L6.405 26.98a.954.954 0 1 1-1.35-1.349l4.198-4.198a.954.954 0 0 1 1.35 0m13.57-2.637a.954.954 0 0 0 0 1.35l4.198 4.197a.954.954 0 1 0 1.35-1.349l-4.199-4.198a.954.954 0 0 0-1.35 0m-2.775 2.637a.954.954 0 0 0 0 1.35l4.198 4.197a.954.954 0 1 0 1.35-1.349l-4.198-4.198a.954.954 0 0 0-1.35 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.848 5.647a.71.71 0 0 0-1.12.452l-1.57 8.944v.576c0 6.008 4.87 10.878 10.877 10.878v1.908c-7.062 0-12.786-5.725-12.786-12.786v-.654q0-.088.015-.175l1.584-9.02c.336-1.91 2.557-2.807 4.124-1.664l4.064 2.963a.7.7 0 0 0 .419.136h2.58v1.909h-2.58a2.62 2.62 0 0 1-1.544-.503z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24.187 5.647a.71.71 0 0 1 1.12.452l1.57 8.944v.576c0 6.008-4.87 10.878-10.877 10.878v1.908c7.061 0 12.786-5.725 12.786-12.786v-.654a1 1 0 0 0-.016-.175l-1.584-9.02c-.335-1.91-2.556-2.807-4.123-1.664l-4.064 2.963a.7.7 0 0 1-.419.136H16v1.909h2.58a2.62 2.62 0 0 0 1.543-.503z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCatOutlineSVG);
ForwardRef.displayName = "IconCatOutline";
export { ForwardRef as IconCatOutline };
